import { updateObject } from 'store/utility';
import * as actionTypes from '../actions/actionTypes';

const INITIAL_STATE = {
    tags: {},
    loading: false,
    relations: {}
}

const TagReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case actionTypes.TAG_CATALOG_SEARCH_START:
            return updateObject(state, { loading: true });
        case actionTypes.TAG_CATALOG_SEARCH_SUCCESS:
            return updateObject(state, { tags: action.tags, loading: false });
        case actionTypes.TAG_CATALOG_SEARCH_FAIL:
            return updateObject(state, { loading: false });
        case actionTypes.TAG_CATALOG_TAGS_REL_SUCCESS:
            const relations = { ...state.relations };
            relations[action.id] = action.rels;
            return updateObject(state, { relations: relations });
        default:
            return state;
    }
}

export default TagReducer;
